import http from "../http-common";

const getAll = async (filters) => {
  const res = await http.get("/services", {
    params: filters,
  });
  return res.data;
};

const get = async (id) => {
  const res = await http.get(`/services/${id}`);
  return res.data;
};

const create = async (data) => {
  const res = await http.post(`/services`, data);
  return res.data;
};

const update = async (id, data) => {
  const res = await http.put(`/services/${id}`, data);
  return res.data;
};

const remove = async (id) => {
  const res = await http.delete(`/services/${id}`);
  return res.data;
};

const ServicesService = {
  getAll,
  get,
  create,
  update,
  remove,
};

export default ServicesService;
